<template>
  <div class="md-card-content">
    <div class="md-layout">
      <div class="md-layout-item md-size-30">
        <label>نوع التقرير</label>
        <model-list-select
          class="input-must-rtl"
          :list="reportList"
          v-model="st"
          option-value="id"
          option-text="name"
          @input="$emit('changeReport', $event)"
        />
      </div>
      <div class="md-layout-item md-size-30">
        <label>المصرف</label>
        <model-list-select
          class="input-must-rtl"
          :list="employeesData.banks"
          v-model="bankId"
          option-value="key"
          option-text="value"
        />
      </div>

      <div class="md-layout-item md-size-30">
        <label>فرع المصرف</label>
        <model-list-select
          class="input-must-rtl"
          :list="bankBranches"
          v-model="bankBranchId"
          option-value="key"
          option-text="value"
          :is-disabled="!bankId"
        />
      </div>

      <!-- 4px بيساوي حافة مدخل الموظف بحافة مدخل التاريخ: حقل التاريخ محتواه
           absolute جوّه md-layout-item-time (margin-top:30px) فبيقع عند 26px،
           والموظف من غير الإزاحة دي بيقع عند 22px. مقيسة في المتصفح. -->
      <div
        class="md-layout-item md-size-30 clear-relative"
        style="margin-top: 4px"
      >
        <label>الموظف</label>
        <model-list-select
          multiple
          class="input-must-rtl"
          :list="employeesData.employees"
          v-model="employeeId"
          option-value="key"
          option-text="value"
        >
        </model-list-select>
        <!-- <ClearButton
          class="absolute-clear-button"
          @click.native="clearfield('employeeId')"
        /> -->
      </div>

      <div
        class="md-layout-item md-layout-item-time md-size-30 ml-15"
        style="position: relative"
      >
        <h4 class="monthly-picker-head" :class="{ active: salaryDate }">
          تاريخ المرتب
        </h4>
        <vue-monthly-picker
          class="monthly-picker"
          alignment="right"
          v-model="salaryDate"
        />
      </div>
    </div>

    <div class="md-layout-item md-size-100 mt-25 mtb-25 text-center">
      <!-- <md-button class="md-info" @click="printPdf"> طباعة PDF </md-button> -->
      <md-button
        class="md-success ml-15"
        :disabled="loadingSearch"
        @click="search"
      >
        <span class="ml-15"> بحث </span>
        <md-progress-spinner
          v-if="loadingSearch"
          class="md-accent"
          :md-diameter="15"
          :md-stroke="2"
          md-mode="indeterminate"
        />
      </md-button>
      <md-button class="md-info" @click="printPdf" :disabled="loading">
        <span class="ml-15"> طباعة PDF </span>
        <md-progress-spinner
          v-if="loading"
          class="md-accent"
          :md-diameter="15"
          :md-stroke="2"
          md-mode="indeterminate"
        />
      </md-button>
    </div>

    <div class="md-layout">
      <div class="md-layout-item">
        <md-card-content>
          <md-table
            dir="rtl"
            :value="allData"
            class="report paginated-table table-striped table-hover mt-25"
          >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="ر.م">{{
                item.documentNumber
              }}</md-table-cell>
              <md-table-cell md-label="الرقم المالي">{{
                item.financialNumber
              }}</md-table-cell>

              <md-table-cell md-label="رقم الحساب"
                >{{ item.accountNumber }}
              </md-table-cell>

              <md-table-cell md-label="صافي المرتب">{{
                formatValues(item.netSalary)
              }}</md-table-cell>

              <md-table-cell md-label="شهر المرتب">{{
                item.salaryDate
              }}</md-table-cell>

              <md-table-cell md-label="اسم الموظف">{{
                item.employeeName
              }}</md-table-cell>
              <md-table-cell md-label="الرقم الوطني">{{
                item.nationalNumber
              }}</md-table-cell>
              <md-table-cell md-label="فرع المصرف">{{
                item.branchName
              }}</md-table-cell>

              <md-table-cell md-label>
                <div class="md-just-icon md-info md-simple"></div>
              </md-table-cell>
            </md-table-row>
          </md-table>

          <p v-if="showEmptyState" class="text-center mt-25">لا توجد نتائج</p>
        </md-card-content>
      </div>
    </div>
  </div>
</template>

<script>
import { ModelListSelect } from "vue-search-select";
import Swal from "sweetalert2";
import moment from "moment";
export default {
  components: {
    ModelListSelect
  },
  props: {
    reportList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      loading: false,
      loadingSearch: false,
      st: "20",
      bankId: null,
      bankBranchId: null,
      bankBranches: [],
      employeeId: null,
      salaryDate: null,
      allData: [],
      // "idle" = لسه ما اتبحثش | "success" = بحث اكتمل | "error" = بحث فشل
      searchStatus: "idle"
    };
  },

  computed: {
    employeesData() {
      return this.$store.getters["global/employeesData"];
    },
    showEmptyState() {
      return this.searchStatus === "success" && this.allData.length === 0;
    }
  },

  watch: {
    bankId(newValue) {
      this.bankBranchId = null;
      this.searchStatus = "idle";

      if (newValue) {
        this.loadBankBranches(newValue);
      } else {
        this.bankBranches = [];
      }
    },
    // watcher منفصل عن بتاع المصرف عن قصد: لو الفرع فاضي أصلًا، ده مش بيتنفّذ
    // لما المصرف يتغيّر — فالتصفير لازم يتعمل في الاتنين.
    bankBranchId() {
      this.searchStatus = "idle";
    }
  },

  methods: {
    clearfield(field) {
      this[field] = null;
    },
    formatValues(value) {
      if (!value) {
        return value;
      }
      return value.toLocaleString();
    },
    validateSchema() {
      if (!this.bankId) {
        Swal.fire({
          title: "يرجى اختيار المصرف",
          icon: "warning"
        });
        return null;
      }

      if (!this.salaryDate) {
        Swal.fire({
          title: "يرجى اختيار تاريخ المرتب",
          icon: "warning"
        });
        return null;
      }

      const params = {
        salaryDate: moment(this.salaryDate).format("YYYY-MM-DD"),
        employeeId: this.employeeId,
        // الفرع اختياري: المكتبة بترجّع "" لما المستخدم يمسح الحقل بالكيبورد،
        // و axios بيحذف الباراميتر لو null بس مش لو "" — فالتطبيع إلزامي هنا
        // عشان الطلب ما يحملش bankBranchId فاضي.
        bankBranchId: this.bankBranchId || null
      };

      return params;
    },
    // الفلاتر اللي الرد بيتنسب لها. رد بحث بيوصل بعد ما أي واحدة فيهم اتغيّرت
    // بيتجاهَل بالكامل — الجدول والمؤشر سوا.
    isStaleResponse(bankId, bankBranchId) {
      // التطبيع على الجهتين عشان "" و null (اللي المكتبة بترجّعهم للحقل الفاضي)
      // يتقارنوا كقيمة واحدة، وما يتحسبش تغيير فلتر وهو مش تغيير.
      const isSame = (current, requested) =>
        (current || null) === (requested || null);

      return (
        !isSame(this.bankId, bankId) || !isSame(this.bankBranchId, bankBranchId)
      );
    },
    async loadBankBranches(bankId) {
      try {
        const { data } = await this.$axios.get(
          `/api/bank-branches/load/${bankId}`
        );
        this.bankBranches = data.data;
      } catch (error) {
        // صامت عن قصد: نفس فلسفة الكمبوننت. مسار الخطأ ده منفصل تمامًا عن
        // مسار خطأ البحث وما بيلمسش searchStatus.
        this.bankBranches = [];
      }
    },
    async search() {
      const requestedBankId = this.bankId;
      const requestedBankBranchId = this.bankBranchId;

      try {
        this.loadingSearch = true;
        const params = this.validateSchema();
        if (!params) {
          return;
        }

        const url = `/api/SalariesReports/EmployeeSalaryPerBank/${this.bankId}`;

        const { data } = await this.$axios.get(url, {
          params
        });

        if (this.isStaleResponse(requestedBankId, requestedBankBranchId)) {
          return;
        }

        this.allData = data.data.map((item, index) => ({
          ...item,
          documentNumber: index + 1
        }));
        this.searchStatus = "success";
      } catch (error) {
        if (this.isStaleResponse(requestedBankId, requestedBankBranchId)) {
          return;
        }
        this.searchStatus = "error";
      } finally {
        this.loadingSearch = false;
      }
    },
    async printPdf() {
      try {
        this.loading = true;

        const params = this.validateSchema();
        if (!params) {
          return;
        }

        const url = `/api/SalariesReports/EmployeeSalaryPerBankReport/${this.bankId}`;
        const fileName = "تقرير المرتبات حسب مصرف";
        const fileType = "pdf";

        const { data } = await this.$axios.get(url, {
          responseType: "blob",
          params
        });

        downloadFile(data, `${fileName}.${fileType}`);

        function downloadFile(blob, name) {
          const href = URL.createObjectURL(blob);
          const a = Object.assign(document.createElement("a"), {
            href,
            style: "display:none",
            download: name
          });
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(href);
          a.remove();
        }
      } catch (error) {
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss"></style>
